<lc-chips class="agent-search" removeByUser = true [class.has-selected]="selected?.length > 0" [emptyPlaceholder]="emptyPlaceholder" [formControl]="formControl"
  [idPrefix]="idPrefix" [inputFormControl]="searchControl" [label]="label"
  [max]="max" [noResultsDisplay]="noResultDisplayText"
  [options]="memberSearch$ | async" [placeholder]="placeholder"
  (selectedChanged)="updateAgents($event)">

  <!--Tag Template -->
  <ng-template #tag let-member="item">
    {{member.firstName}} {{member.lastName}}
  </ng-template>

  <!-- Template to display the member -->
  <ng-template #option let-member="item">
    <div class="row align-items-center m-0">
      <lc-avatar class="agent-avatar" [photoUrl]="member?.profilePhotoUrl || member?.photoUrl" [size]="38" />
      <div class="ml-2 d-inline-block" style="line-height: 1em">
        {{member.firstName}} {{member.lastName}}<br>
        {{member.officeName}}
      </div>
    </div>
  </ng-template>

</lc-chips>
